module.exports = __webpack_public_path__ + "img/unlocking_icon.dcabe84b.png";